import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Gift, Copy, Check, Users, CalendarPlus } from "lucide-react";

const ReferralCard = () => {
  const [info, setInfo] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/referral").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  const link = info ? `${window.location.origin}/register?ref=${info.code}` : "";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link);
      setCopied(true);
      toast.success("Referral link copied!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy");
    }
  };

  return (
    <div className="rounded-xl border border-primary/30 bg-gradient-to-b from-primary/10 to-transparent p-6" data-testid="referral-card">
      <div className="flex items-center gap-2 mb-3">
        <div className="w-9 h-9 rounded-lg bg-primary/15 text-primary flex items-center justify-center"><Gift className="w-4.5 h-4.5" style={{ width: 18, height: 18 }} /></div>
        <h3 className="font-heading text-lg font-semibold">Refer & earn</h3>
      </div>
      <p className="text-sm text-muted-foreground mb-4">
        Get <span className="text-primary font-bold">+{info?.bonus_per_referral ?? 7} bonus growth days</span> each time a friend subscribes with your link.
      </p>
      <div className="flex gap-2">
        <Input readOnly value={link} className="h-11 bg-transparent border-white/10 text-sm font-mono" data-testid="referral-link-input" />
        <Button onClick={copy} className="h-11 rounded-lg bg-primary text-background font-bold shrink-0" data-testid="copy-referral-btn">
          {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
        </Button>
      </div>
      <div className="grid grid-cols-2 gap-3 mt-5">
        <div className="rounded-lg bg-white/5 border border-white/5 p-4">
          <div className="flex items-center gap-2 text-muted-foreground text-xs mb-1"><Users className="w-3.5 h-3.5" /> Referrals</div>
          <div className="font-heading text-2xl font-black" data-testid="referral-count">{info?.referrals ?? 0}</div>
        </div>
        <div className="rounded-lg bg-white/5 border border-white/5 p-4">
          <div className="flex items-center gap-2 text-muted-foreground text-xs mb-1"><CalendarPlus className="w-3.5 h-3.5" /> Bonus days</div>
          <div className="font-heading text-2xl font-black text-primary" data-testid="referral-bonus">{info?.bonus_days ?? 0}</div>
        </div>
      </div>
    </div>
  );
};

export default ReferralCard;
